const NAMESPACE = 'jbp-section-loading'

export const SECTION_LOADING_TRANSLATION_KEYS = {
  // The `{name}` param is the section's own name, e.g. `Financial & SOB Plan`.
  named: `${NAMESPACE}--named`, // Loading {name}
  plain: `${NAMESPACE}--plain`, // Loading…
}
